import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6c4b88b9")

_pushScopeId("data-v-6c4b88b9")
const _hoisted_1 = {
  class: "svg-map-root",
  ref: "bodyRef"
}
const _hoisted_2 = {
  key: 2,
  class: "bead-content"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_bead = _resolveComponent("bead")
  const _component_big_road = _resolveComponent("big-road")
  const _component_big_eye = _resolveComponent("big-eye")
  const _component_small_road = _resolveComponent("small-road")
  const _component_cockroach = _resolveComponent("cockroach")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.display === 0)
      ? (_openBlock(), _createBlock("div", {
          class: "svg-content",
          key: _ctx.tableKey + '_v1'
        }, [
          _createVNode("table", { style: _ctx.beadWidth }, [
            (_openBlock(), _createBlock(_Fragment, null, _renderList(6, (i) => {
              return _createVNode("tr", {
                key: `bead-box-row-${i}`,
                class: "px"
              }, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.beadRowCount, (x) => {
                  return (_openBlock(), _createBlock("td", {
                    key: `bead-box-col-${x}`,
                    style: _ctx.tdStyle
                  }, null, 4))
                }), 128))
              ])
            }), 64))
          ], 4),
          _createVNode("table", {
            style: _ctx.otherTableStyle,
            cellspacing: "0",
            cellpadding: "0"
          }, [
            (_openBlock(), _createBlock(_Fragment, null, _renderList(12, (i) => {
              return _createVNode("tr", {
                key: `bead-box-row-${i}`,
                class: "px"
              }, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.beadRow, (x) => {
                  return (_openBlock(), _createBlock("td", {
                    key: `bead-box-col-${x}`,
                    style: _ctx.otherTdStyle
                  }, null, 4))
                }), 128))
              ])
            }), 64))
          ], 4)
        ]))
      : (_ctx.display === 1)
        ? (_openBlock(), _createBlock("div", {
            class: "svg-content",
            key: _ctx.tableKey + '_v2'
          }, [
            _createVNode("table", { style: _ctx.beadWidth }, [
              (_openBlock(), _createBlock(_Fragment, null, _renderList(12, (i) => {
                return _createVNode("tr", {
                  key: `bead-box-row-${i}`
                }, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.beadRow, (x) => {
                    return (_openBlock(), _createBlock("td", {
                      key: `bead-box-col-${x}`,
                      style: _ctx.tdStyleD1
                    }, null, 4))
                  }), 128))
                ])
              }), 64))
            ], 4)
          ]))
        : _createCommentVNode("", true),
    (_ctx.display === 0)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.svgData.beads, (i, index) => {
            return (_openBlock(), _createBlock(_component_bead, {
              class: "bead",
              style: _ctx.getBeadStyle(i),
              key: `bead-item-${index}`,
              gameType: _ctx.gameType,
              mdata: i
            }, null, 8, ["style", "gameType", "mdata"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", {
      style: _ctx.bigContentStyle(),
      class: "_big"
    }, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.svgData.bigs, (i, index) => {
        return (_openBlock(), _createBlock(_component_big_road, {
          key: `big-item-${index}`,
          mdata: i,
          style: _ctx.getBigStyle(i)
        }, null, 8, ["mdata", "style"]))
      }), 128))
    ], 4),
    _createVNode("div", {
      style: _ctx.bigeyeContentStyle(),
      class: "_bigeye"
    }, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.svgData.bigeyes, (i, index) => {
        return (_openBlock(), _createBlock(_component_big_eye, {
          key: `big-item-${index}`,
          mdata: i,
          style: _ctx.getSmallStyle(i)
        }, null, 8, ["mdata", "style"]))
      }), 128))
    ], 4),
    _createVNode("div", {
      style: _ctx.smallContentStyle(),
      class: "_small"
    }, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.svgData.smalls, (i, index) => {
        return (_openBlock(), _createBlock(_component_small_road, {
          key: `big-item-${index}`,
          mdata: i,
          style: _ctx.getSmallStyle(i)
        }, null, 8, ["mdata", "style"]))
      }), 128))
    ], 4),
    _createVNode("div", {
      style: _ctx.cockroachContentStyle(),
      class: "_cockroach"
    }, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.svgData.cockroaches, (i, index) => {
        return (_openBlock(), _createBlock(_component_cockroach, {
          key: `big-item-${index}`,
          mdata: i,
          style: _ctx.getSmallStyle(i)
        }, null, 8, ["mdata", "style"]))
      }), 128))
    ], 4)
  ], 512))
})